import React, { useEffect, useState } from "react";

export function initialsOf(name, id) {
  const source = (name || id || "?").trim();
  const words = source.split(/\s+/).filter(Boolean);
  if (words.length >= 2) {
    return (words[0][0] + words[1][0]).toUpperCase();
  }
  return source.slice(0, 2).toUpperCase();
}

// Shows the organization image when available, otherwise falls back to its
// initials. `className` controls sizing/shape (shared by the img and the span).
export function OrgAvatar({ name, id, image, className = "" }) {
  const [broken, setBroken] = useState(false);

  useEffect(() => {
    setBroken(false);
  }, [image]);

  if (image && !broken) {
    return (
      <img
        src={image}
        alt=""
        className={className}
        onError={() => setBroken(true)}
      />
    );
  }

  return <span className={className}>{initialsOf(name, id)}</span>;
}
